import styled from "styled-components";

export const ChartWrapper = styled.div`
  width: 40vw;
  height: 40vh;
  background: #f5f5f5;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
`;
